require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./enrolments-pages-enrolment-promotion.json") })
        }
      }, "path---enrolments-pages-enrolment-promotion");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---enrolments-pages-enrolment-promotion!./.cache/json/enrolments-pages-enrolment-promotion.json
// module id = 1235
// module chunks = 231608221292675